const { clientQuery } = require('../queries');
const shippingMethodsByCartQuery = require('../../queries/shipping/shippingMethodsByCartQuery.js');
const localizationDefinitions = require('../../../../i18n/localizationDefinitions.ts').default;
const handleCtApiError = require('../handleCtApiError');
const { CUSTOM_QUERIES } = require('../../../../constants/customQueries.js');

/**
 * Endpoint for fetching shipping methods available for the given cart.
 *
 * @param {Context} context - Automatically injected context
 * @param {string} cartId - User cart ID
 * @param {Maybe<CustomQuery>} customQuery - Custom queries included in the request
 * @returns - Shipping methods data
 */
const getShippingMethods = async function(context, cartId, customQuery = {}) {
  const { country } = context.config;
  const acceptLanguage = localizationDefinitions.getByCountryCode(country)
    .getAcceptedLanguages();

  const defaultVariables = {
    acceptLanguage,
    cartId,
  };

  // Use the context extendQuery to possibly override the query
  const { shippingMethods } = context.extendQuery(customQuery, {
    shippingMethods: shippingMethodsByCartQuery[CUSTOM_QUERIES.SHIPPING.shippingMethods.shippingMethodsByCart]({
      variables: defaultVariables,
    }),
  });

  try {
    const response = await clientQuery(context, {
      query: shippingMethods.query,
      variables: shippingMethods.variables,
    });
    return response;
  } catch (error) {
    throw handleCtApiError(error);
  }
};

module.exports = getShippingMethods;
